import { render, staticRenderFns } from "./VIconNext.vue?vue&type=template&id=3fc37a7b&scoped=true&"
import script from "./VIconNext.vue?vue&type=script&lang=ts&"
export * from "./VIconNext.vue?vue&type=script&lang=ts&"
import style0 from "./VIconNext.vue?vue&type=style&index=0&id=3fc37a7b&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3fc37a7b",
  null
  
)

export default component.exports